import { render } from "./recycle-request.vue?vue&type=template&id=2d86b6f6"
import script from "./recycle-request.vue?vue&type=script&setup=true&lang=js"
export * from "./recycle-request.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/recycle/recycle-request.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d86b6f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d86b6f6', __exports__)) {
    api.reload('2d86b6f6', __exports__)
  }
  
  module.hot.accept("./recycle-request.vue?vue&type=template&id=2d86b6f6", () => {
    api.rerender('2d86b6f6', render)
  })

}


export default __exports__